import { APIProvider, Map } from "@vis.gl/react-google-maps";
import { Outlet } from "react-router-dom";

const MapKMLViewer = () => {
  return (
    <>
      <APIProvider
        apiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
        libraries={["marker"]}
        region="MA"
      >
        <Map
          defaultCenter={{ lat: 29.84992, lng: -8 }}
          defaultZoom={6}
          gestureHandling="greedy"
          className="h-[calc(100%-65px)]"
          mapTypeId="hybrid"
          disableDefaultUI={true}
          zoomControl={true}
        />
        <Outlet />
      </APIProvider>
    </>
  );
};

export default MapKMLViewer;
